import JSON_CURRENCY_INFO from "../json/currencies.json";
import { useCallback, useMemo } from "react";
import { sortBy } from "lodash";
import { capitalizeTitle, transformToSelectOptions } from "src/helpers/utils";
import useLanguages from "./useLanguages";
import { DEFAULT_LANGUAGE } from "src/helpers/constants";
import { ECustomSelectIconType } from "src/components/Select/CustomSelect";

export default function useCurrencies() {
  const { currentLanguageId } = useLanguages();

  const allCurrencies = useMemo(() => {
    return JSON_CURRENCY_INFO.map((currency: any) => {
      return {
        ...currency,
        name:
          currentLanguageId === DEFAULT_LANGUAGE
            ? capitalizeTitle(currency.name)
            : capitalizeTitle(
                currency[`name_${currentLanguageId}`] || currency.name,
              ),
        name_plural:
          currentLanguageId === DEFAULT_LANGUAGE
            ? capitalizeTitle(currency.name_plural)
            : capitalizeTitle(
                currency[`name_plural_${currentLanguageId}`] ||
                  currency.name_plural,
              ),
      };
    });
  }, [currentLanguageId]);

  const currencySelectOptions = useMemo(() => {
    return sortBy(
      transformToSelectOptions({
        data: allCurrencies,
        labelField: "name",
        valueField: "code",
      }),
      ["label"],
    ).map((currency: any) => {
      return {
        ...currency,
        iconType: ECustomSelectIconType.CURRENCY,
        icon: currency.value,
      };
    });
  }, [allCurrencies]);

  const getCurrencyDataByCode = useCallback(
    ({ code }: { code: string }) => {
      return allCurrencies.find(({ code: theCode }) => theCode === code);
    },
    [allCurrencies],
  );

  return {
    allCurrencies,
    currencySelectOptions,
    getCurrencyDataByCode,
  };
}
